import Container from '../lib/gui/dom/Container';
import Utils from '../../utils/Utils';
import EpgConstants from './EpgConstants';
import EpgPersistence from './EpgPersistence';
import { Dates } from '../../packages/dates';
import  Translator  from '../../requests/apa/Translator';

export default class TimeBarController {

  constructor(scheduleList) {
    this.scheduleList = scheduleList;
    this.scheduleListGUI = [];

    this.paintSchedule = this.paintSchedule.bind(this);
    this.setRedrawGridCallback = this.setRedrawGridCallback.bind(this);
    this.setLoadingCallback = this.setLoadingCallback.bind(this);
    this.getMaxTimeCallback = this.getMaxTimeCallback.bind(this);
    this.getMinTimeCallback = this.getMinTimeCallback.bind(this);
    this.setIsDrawing = this.setIsDrawing.bind(this);
    
    this.scheduleList.setPaintSchedule(this.paintSchedule);

    this.redrawGridCallback = null;
    this.opacityCallback = null;
    this.maxTimeCallback = null;
    this.minTimeCallback = null;
    this.isDrawingCallback = null;
    this.totalColumnsWidth = 1120; //pixels
    this.timeWindowLength = EpgConstants.TIMELINE_CELL_SIZE_MS * EpgConstants.TOTAL_TIMELINE_INTERVALS;
    this.columns = EpgConstants.TOTAL_TIMELINE_INTERVALS;
    this.columnsInterval = EpgConstants.TIMELINE_CELL_SIZE_MS / (60 * 1000); //Minutes
    this.componentToday = null;
  }

  /**
   * 
   * @param {*} parentElement AAF Element instance to add this child to
   */
  initialise(parentElement) {
    this.mainContainer = new Container(parentElement, { className: 'time-bar-group', id: 'timeBarGroup' });
    //let componentTable = new Container(null, { className: 'time-bar-table', id: 'timeBarTable' });
    this.componentToday = new Container(null, { className: 'time-bar-today', id: 'timeBarToday' });
    
    this.mainContainer.addChild(this.componentToday);
    const list = this.scheduleList.list;
    const style = { width: `${this.totalColumnsWidth / this.columns}px` };
    if (list && Array.isArray(list) && list.length > 0) {  
      for (let i = 0; i <= list.length - 1; i++) {
        let component = new Container(null, { className: 'time-bar-scheduled', id: 'scheduled-' + i });
        //component.setText(Utils.getEPGDateToString(new Date(list[i])));
        const calculateText = this.calculateTextTimeBar(list[i]);
        component.setText(calculateText);
        component.setStyle(style);
        this.mainContainer.addChild(component);
        this.scheduleListGUI.push(component);
      }
    }
    this.componentToday.setText(this.calculateTextDay(list));
  }

  calculateTextTimeBar(currentDate){
    const today = new Dates().unix(Utils.now(true).unix());
    const todayOffset = EpgPersistence.needsOffset() ? today.utcOffset(EpgPersistence.needsOffset(),false).format('YYYY/MM/DD'): today.format('YYYY/MM/DD');
    const dateText = EpgPersistence.needsOffset() ?
                 (`${todayOffset === new Dates().unix(currentDate).utcOffset(EpgPersistence.needsOffset(),false).format('YYYY/MM/DD') ? new Dates().unix(currentDate).utcOffset(EpgPersistence.needsOffset(),false).format('HH.mm') : new Dates().unix(currentDate).utcOffset(EpgPersistence.needsOffset(),false).format('DD/MM HH.mm')}hs.`): 
                 `${todayOffset === new Dates().unix(currentDate).format('YYYY/MM/DD') ? new Dates().unix(currentDate).format('HH.mm'): new Dates().unix(currentDate).format('DD/MM HH.mm')}hs.`;                
    return dateText;
  }

  calculateTextDay(list){
    const today = new Dates().unix(Utils.now(true).unix());
    const todayOffset = EpgPersistence.needsOffset() ? today.utcOffset(EpgPersistence.needsOffset(),false): today;
    const tomorrow = new Dates(todayOffset).add(1, 'days');
    const yesterday = new Dates(todayOffset).subtract(1,'days');
    const todayString = todayOffset.format('YYYY/MM/DD');
    const tomorrowString = tomorrow.format('YYYY/MM/DD');
    const yesterdayString = yesterday.format('YYYY/MM/DD');

    const result = [];
    if (list && Array.isArray(list) && list.length > 0) {
      for (let i = 0; i <= list.length - 1; i++) {
        const date = EpgPersistence.needsOffset() ? new Dates().unix(list[i]).utcOffset(EpgPersistence.needsOffset(),false): new Dates().unix(list[i]);
        const dateString = date.format('YYYY/MM/DD');
        if(dateString === yesterdayString){
          result.push(EpgConstants.YESTERDAY_LABEL);
        }else if(dateString === todayString){
          result.push(EpgConstants.TODAY_LABEL);
        }else if(dateString === tomorrowString){
          result.push(EpgConstants.TOMORROW_LABEL);
        }
      }
    }
    let timeLabel = result.length > 0  ? this.calculateLabel(result): ''; 
    return timeLabel;
  }

  calculateLabel(myArray = []){
    if(myArray && Array.isArray(myArray)){
      let label = myArray.reduce((a,b,i,arr)=>(arr.filter(v=>v===a).length>=arr.filter(v=>v===b).length?a:b),null) || '';
      switch(label){
        case EpgConstants.YESTERDAY_LABEL:
          label = Translator.get('playingLive_fullEpg_title_pastDay_label', 'AYER');
        break;
        case EpgConstants.TODAY_LABEL:
          label = Translator.get('playingLive_fullEpg_title_presentDay_label', 'HOY');
        break;
        case EpgConstants.TOMORROW_LABEL:
          label = Translator.get('playingLive_fullEpg_title_futureDay_label', 'MAÑANA');
        break;
        default:
          label = '';
      }
      return label;
    }
  }

  setRedrawGridCallback(callback) {
    this.redrawGridCallback = callback;
  }

  setLoadingCallback(callback) {
    this.opacityCallback = callback;    
  }

  getMaxTimeCallback(callback) {
    this.maxTimeCallback = callback;
  }

  getMinTimeCallback(callback) {
    this.minTimeCallback = callback;
  }

  setIsDrawing(callback) {
    this.isDrawingCallback = callback;
  }

  paintSchedule(scheduleList, redraw = false ) {
    if (scheduleList && Array.isArray(scheduleList) && scheduleList.length > 0) {
      for (let c in this.scheduleListGUI) {
        const calculateText = this.calculateTextTimeBar(scheduleList[c]);
        this.scheduleListGUI[c].setText(calculateText);
      }
      this.componentToday.setText(this.calculateTextDay(scheduleList));

      if (redraw && this.redrawGridCallback) {
        this.redrawGridCallback(this.getStartTime(), this.getEndTime());
      }

    }
  }

  getStartTime() {
    const startTime = this.scheduleList.list[0];    
    return startTime//.valueOf() / 1000;
  }

  getEndTime() {
    const endTime = new Dates().unix(this.scheduleList.list[this.scheduleList.list.length -1]).add(30,'m');//Utils.addHour(new Date(this.scheduleList.list[this.scheduleList.list.length -1]), .5);
    return endTime.unix();//endTime.valueOf() / 1000;
  }

  setStartTime(st) {
    this.scheduleList.move(st)
  }

  gridOpacity(opacity) {
    this.opacityCallback(opacity);
  }

  getMaxTime() {
    return this.maxTimeCallback();
  }

  async getMinTime() {
    return await this.minTimeCallback();
  }
  

  async keyHandler(keyName, event, repeats) {

    if (this.isDrawingCallback()) {      
      return;
    }
    
    let resp = true;

    if (keyName == 'LEFT' && repeats) {
      const minTime = await this.getMinTime();      
      if (this.getStartTime() > minTime) {
        this.gridOpacity(EpgConstants.ACTIONS_LOADING.OPACITY);
        this.scheduleList.movePageLeft(repeats);
      }
      else {        
        return;
      }
      
    } 
    else if (keyName == 'RIGHT' && repeats) {
      this.gridOpacity(EpgConstants.ACTIONS_LOADING.OPACITY);
      if (this.getEndTime() < this.getMaxTime()) {
        this.scheduleList.movePageRight(repeats);
      }
      else {        
        return;
      }
    } 
    else if ((keyName == 'LEFT_UP' || keyName == 'RIGHT_UP') && repeats) {
      if (this.redrawGridCallback) {      
        let keyDirection = keyName == 'LEFT_UP' ? EpgConstants.GRIDEVENT_LEFT_NAVIGATION : EpgConstants.GRIDEVENT_RIGHT_NAVIGATION;       
        this.redrawGridCallback(this.getStartTime(), this.getEndTime(), keyDirection);
      }
    } 
    else {
      resp = false;
    }

    return resp;
  }
}



// WEBPACK FOOTER //
// ./src/AAF/Nepg/TimeBarController.js